import React from 'react';
import Header from '../Header';
import AlertBanner from '../AlertBanner/AlertBanner';
import NotificationIcon from 'app/assets/svgIcons/NotificationIcon';
import NotificationModal from '../NotificationModal/NotificationModal';
import { SideNavTooltip } from '../SideNavTooltip';
import styles from '../SlideOutPanel.module.scss';

type HeaderComponentProps = React.ComponentProps<typeof Header>;

export type SlideoutHeaderShellProps = {
  headerProps: HeaderComponentProps;
  showNewItemBanner?: boolean;
  onDismissNewItemBanner?: () => void;
  showErrorBanner?: boolean;
  errorMessage?: string;
  onDismissErrorBanner?: () => void;
};

/**
 * Header + alert banners (Part 2B-5).
 */
export function SlideoutHeaderShell({
  headerProps,
  showNewItemBanner,
  onDismissNewItemBanner,
  showErrorBanner,
  errorMessage,
  onDismissErrorBanner
}: SlideoutHeaderShellProps) {
  return (
    <>
      <Header data-testid="slideout-header" {...headerProps} />

      {showNewItemBanner && (
        <AlertBanner
          data-testid="slideout-new-item-banner"
          message="New Roadmap item has been created, please ensure all key fields are filled."
          isVisible={showNewItemBanner}
          onClose={() => onDismissNewItemBanner && onDismissNewItemBanner()}
          type="informative"
        />
      )}

      {showErrorBanner && (
        <AlertBanner
          data-testid="slideout-error-banner"
          message={errorMessage || ''}
          isVisible={showErrorBanner}
          onClose={() => onDismissErrorBanner && onDismissErrorBanner()}
          type="error"
        />
      )}
    </>
  );
}

export type SlideoutNotificationBellProps = {
  notificationPopoverRef: React.Ref<HTMLDivElement>;
  notificationButtonRef: React.Ref<HTMLButtonElement>;
  isNotificationModalOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
  alertCount: number;
  activeIssues: any[];
  momentName: string;
  onIssueClick: (issue: any) => void;
};

/**
 * Side-nav notification bell + modal (Part 2B-5).
 */
export function SlideoutNotificationBell({
  notificationPopoverRef,
  notificationButtonRef,
  isNotificationModalOpen,
  onToggle,
  onClose,
  alertCount,
  activeIssues,
  momentName,
  onIssueClick
}: SlideoutNotificationBellProps) {
  return (
    <div
      ref={notificationPopoverRef}
      className={styles.notificationPopoverRoot}
    >
      <SideNavTooltip label="RSD Notifications">
        <button
          ref={notificationButtonRef}
          type="button"
          className={`${isNotificationModalOpen ? styles.active : ''} ${
            styles.notificationButton
          }`}
          onClick={onToggle}
          aria-label="RSD Notifications"
        >
          <NotificationIcon width={20} height={20} badgeCount={alertCount} />
        </button>
      </SideNavTooltip>
      <NotificationModal
        isOpen={isNotificationModalOpen}
        onClose={onClose}
        issues={activeIssues}
        momentName={momentName}
        popoverContainerRef={
          notificationPopoverRef as React.RefObject<HTMLElement | null>
        }
        onIssueClick={onIssueClick}
      />
    </div>
  );
}
